import React from 'react';
import './portfolio.css';
import IMG1 from '../../assets/img/bee1.jpg';
import IMG2 from '../../assets/img/bird1.jpg';
import IMG3 from '../../assets/img/car1.jpg';
import IMG4 from '../../assets/img/duck1.jpg';
import IMG5 from '../../assets/img/grove1.jpg';
import IMG6 from '../../assets/img/butterfly1.jpg';

const data = [
    {
      id: 1,
      image: IMG1,
      title: 'Crypto Currency Dashboard & Financial Visualization',
      github: 'https://github.com',
      demo: 'https://github.com'
    },
    {
      id: 2,
      image: IMG1,
      title: 'Crypto Currency Dashboard & Financial Visualization',
      github: 'https://github.com',
      demo: 'https://github.com'
    },
    {
      id: 3,
      image: IMG1,
      title: 'Crypto Currency Dashboard & Financial Visualization',
      github: 'https://github.com',
      demo: 'https://github.com'
    },
    {
      id: 4,
      image: IMG1,
      title: 'Crypto Currency Dashboard & Financial Visualization',
      github: 'https://github.com',
      demo: 'https://github.com'
    },
    {
      id: 5,
      image: IMG1,
      title: 'Crypto Currency Dashboard & Financial Visualization',
      github: 'https://github.com',
      demo: 'https://github.com'
    },
    {
      id: 6,
      image: IMG1,
      title: 'Crypto Currency Dashboard & Financial Visualization',
      github: 'https://github.com',
      demo: 'https://github.com'
    }
]


const portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>
      My Work
      </h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
          {
            data.map(({id, image, title, github, demo}) => {
              return (
                  <article key={id} className='portfolio__item'>
                      <div className="portfolio__item-image">
                          <img src={image} alt={title} />
                      </div>
                      <h3>{title}</h3>
                      <div className="portfolio__item-cta">
                          <a href={github} className='btn'>Github</a>
                          <a href={demo} className='btn btn-primary' target="_blank">Live Demo</a>
                      </div>
                  </article>
              )
            })
          }
        
        
      </div>
    </section>
  )
}

export default portfolio;